<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Verification Code</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">
                <div class="main-card text-center">
                    <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                    <div class="rate-box otp-box otp">
                        <div class="form-card-forms">
                            <h4 class="detail">To proceed, please enter your OTP number</h4>
                            <div class="otp-form">
                                <form @submit.prevent="onSubmit" novalidate="" autocomplete="off">
                                    <div class="form-group">
                                        <input type="text" class="form-control otp" id="otp" name="OTP" v-only-numeric="" style="height:72px"
                                               autocomplete="off"
                                               v-model="vModel.Key"
                                               v-validate="'required|min:6|max:6'"
                                               :class="{'input': true, 'is-danger': errors.has('OTP') }" />
                                        <div v-show="errors.has('OTP')"
                                             class="help is-danger">
                                            {{ errors.first('OTP') }}
                                        </div>
                                    </div>
                                    <button class="btn main-btn">Verify</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <h4 class="detail" style="color:#333">Note: We've sent a 6-digit verification code to : <b>{{vModel.username}}</b></h4>
                    <div class="rate-option-btn">
                        <div class="submit-option maxw-700">
                            <div class="left-option">
                                <router-link :to="'/account/login'" class="btn submit-lefticon-btn">
                                    <span class="left-icon">
                                        <i class="material-icons">chevron_left</i>
                                    </span>
                                    <span class="btn-content">Cancel</span>
                                </router-link>
                            </div>
                            <div class="right-option">
                                <p>
                                    Didn't get the code? <a href="javascript:void(0)" class="resend" @click="onResendOtp">Resend OTP?</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- eo main card -->
                </div>
				<!-- eo main card -->
			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
  <script>
    import Base from "../../shared/Base.vue";
    import Action from "../../shared/Action.vue";
    import Mode from "../../shared/Mode.vue";
    import welcome from "../../shared/Welcome.vue";

    import { vueinstance } from "../../main";
    import authservice from "../../services/authservice";

    export default {
	  name: "Confirm Phone number",
      extends: Base,
      components: {
        Action,
        Mode,welcome
      },
      created() {
        this.url.init = "mobile/confirm/mobile/otprequest";
        this.url.update = "account/confirmforgotpassword";
      },
      beforeRouteEnter(to, from, next) {
		var promises = [];
            promises.push(
                window.Vue.$http.get('account/otpdetail/' + to.params.id)
            );

            Promise.all(promises).then(response => {
                next(p => {
                    p.vModel.username = (response[0].body.IsEmail) ? response[0].body.Username : "+" + response[0].body.Username;
					p.vModel.OtpId = to.params.id
                })
            });
          
    },
      data() {
        return {};
      },
      methods: {
        onSubmit: function () {
          var self = this;
          if (self.isProcessing) return false;
          self.$validator.validateAll().then(result => {
            if (result && self.beforeSave()) {
              self.isProcessing = true;
              self.$http.post(self.url.update, self.vModel).then(
                response => {
                    self.$router.push("/account/resetpassword?code="+response.body.Code+"&userid="+response.body.UserId);                     
                },
                error => {
                  self.isProcessing = false;
                }
              );
            }
          });
        },
        onResendOtp: function () {
          var self = this;
          self.isProcessing = true;
          self.$http.post("mobile/otp/resend", self.vModel).then(
            response => {
              self.$toastr("success", "OTP Resend Successfully");
              self.isProcessing = false;
            },
            error => {
              self.isProcessing = false;
            }
          );
        },
        onClearForm: function () {
          this.vModel = getDefaultData();
          this.errors.clear();
        }
      }
    };
    function getDefaultData() {
      return {
        OtpId: "",
        Key: ""
      };
    }
  </script>
